export const layout = {
  containerWidth: '1180px',
  containerSideSpacing: '30px',
  headerHeight: '100px',
}